import { useEffect, useState } from "react";
import { useListControls, ListControlsBar } from "@/components/ListSearchSort";
import api from "@/lib/api";
import { History, ArrowRight } from "lucide-react";

export default function AuditLog() {
  const [items, setItems] = useState([]);
  const ctl = useListControls(items, { name: (e) => e.target_name || e.actor_name, fields: (e) => [e.actor_name, e.actor_email, e.target_name, e.target_email], initialSort: "default" });

  useEffect(() => {
    api.get("/admin/audit-log?limit=200").then((r) => setItems(r.data));
  }, []);

  return (
    <div className="space-y-6" data-testid="audit-log">
      <div className="fade-up">
        <div className="label-mono mb-2 flex items-center gap-2"><History className="w-3.5 h-3.5 text-[#CCFF00]" /> SUPER ADMIN · AUDIT TRAIL</div>
        <h1 className="h-display text-5xl tracking-tighter">Who changed what.</h1>
        <div className="text-sm text-[#A3A3A3] mt-1 max-w-2xl">A permanent record of permission changes. New entries write automatically every time roles are saved on Users &amp; Roles.</div>
      </div>

      {!items.length && (
        <div className="card-surface p-12 text-center fade-up d1">
          <History className="w-10 h-10 text-[#262626] mx-auto mb-4" strokeWidth={1.5} />
          <div className="text-sm text-[#A3A3A3]">No audit entries yet. Make a permission change to populate this log.</div>
        </div>
      )}

      {items.length > 0 && <ListControlsBar ctl={ctl} modes={["default", "az", "za"]} placeholder="Search by name or email…" testid="audit" />}
      <div className="card-surface fade-up d1 divide-y divide-[#262626]">
        {ctl.list.map((e) => {
          const before = (e.before?.permissions || []).join(", ") || "—";
          const after = (e.after?.permissions || []).join(", ") || "—";
          return (
            <div key={e.id} className="p-5 flex items-start gap-4 flex-wrap" data-testid={`audit-${e.id}`}>
              <div className="w-1 self-stretch min-h-[40px]" style={{ background: "#CCFF00" }} />
              <div className="flex-1 min-w-[200px]">
                <div className="flex items-center gap-2 flex-wrap mb-1">
                  <span className="label-mono text-[#CCFF00]">{(e.action || "unknown").replace(/_/g, " ").toUpperCase()}</span>
                  <span className="text-xs text-[#A3A3A3]">{e.created_at?.slice(0, 16).replace("T", " ")}</span>
                </div>
                <div className="text-sm">
                  <span className="font-semibold">{e.actor_name}</span>
                  <span className="text-[#A3A3A3]"> ({e.actor_email}) changed </span>
                  <span className="font-semibold">{e.target_name}</span>
                </div>
                <div className="text-xs text-[#A3A3A3] mt-2 font-mono inline-flex items-center gap-2 flex-wrap">
                  <span className="px-2 py-0.5 border border-[#262626]">{before}</span>
                  <ArrowRight className="w-3 h-3" />
                  <span className="px-2 py-0.5" style={{ background: "#CCFF00", color: "#0A0A0A", fontWeight: 700 }}>{after}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
